const DEFAULT_ERROR_MESSAGE = 'An error occurred';

class ScanToPrintErrorServiceClass {
  getUnknownErrorMessage() {
    return DEFAULT_ERROR_MESSAGE;
  }

  isUnknownErrorMessage(message) {
    return message === DEFAULT_ERROR_MESSAGE;
  }
}

export const ScanToPrintErrorService = new ScanToPrintErrorServiceClass();
